<template>
  <table-create-drawer
    :is-visible="value"
    :halls="halls"
    :initial-customer-ids="initialCustomerIds"
    @close="onClose"
    @created="onCreated"
  />
</template>

<script>
import {
  ref,
  computed,
  watch,
  provide,
} from '@vue/composition-api'
import HallApi from '@/api/waiter/Hall'
import UserApi from '@/api/waiter/User'
import CustomerApi from '@/api/waiter/Customer'
import TableCreateDrawer from '@/views/components/table/TableCreateDrawer.vue'

export default {
  name: 'CreateTableFromCustomerDialog',
  components: {
    TableCreateDrawer,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: Object,
      default: () => null,
    },
  },
  setup(props, { emit }) {
    const halls = ref([])
    const users = ref([])

    // TableCreateDrawer が inject する
    provide('users', users)

    // CustomerSelect が inject する（フォールバックあるが明示的に提供）
    const searchCustomers = async (query = '') => {
      if (!query || query.trim().length === 0) return []
      try {
        const res = await CustomerApi.getCustomers({ q: query.trim() })
        if (res?.data?.data) return res.data.data
      } catch (error) {
        // ignore
      }

      return []
    }
    provide('searchCustomers', searchCustomers)

    const initialCustomerIds = computed(() => {
      return props.customer?.id ? [props.customer.id] : []
    })

    const fetchHalls = async () => {
      try {
        const res = await HallApi.getHalls({ isOperation: true })
        if (res?.data?.halls?.data) {
          halls.value = res.data.halls.data
        }
      } catch (error) {
        // ignore
      }
    }

    const fetchUsers = async () => {
      try {
        const res = await UserApi.getUsers()
        if (res?.data?.users?.data) {
          users.value = res.data.users.data
        }
      } catch (error) {
        // ignore
      }
    }

    watch(
      () => props.value,
      newVal => {
        if (newVal) {
          fetchHalls()
          fetchUsers()
        }
      },
    )

    const onClose = () => {
      emit('input', false)
    }

    const onCreated = data => {
      emit('input', false)
      emit('created', data)
    }

    return {
      halls,
      initialCustomerIds,
      onClose,
      onCreated,
    }
  },
}
</script>
